import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import NotificationsPopover from "@/features/notifications/popover";
import AccountPopover from "@/features/account/popover";
import PrmeLogo from "@/assets/icons/prme-logo.png";
import { SIDEBAR_TRIGGER_VARIANT } from "@/layouts/AuthenticatedLayout/Sidebar/types";
import NotificationsSidebarTrigger from "@/layouts/AuthenticatedLayout/Sidebar/Notifications/NotificationsSidebarTrigger";
import AccountSidebarTrigger from "@/layouts/AuthenticatedLayout/Sidebar/Account/AccountSidebarTrigger";
import type { MobileHeaderProps } from "./types";

import "./styles.css";

const MobileHeader = ({
  currentUser,
  onMenuClick,
  className,
}: MobileHeaderProps) => {
  const { t } = useTranslation();

  return (
    <header className={`mobile-header flex items-center ${className ?? ""}`}>
      <div className="mobile-header-action-slot flex flex-shrink-0 justify-center items-center">
        <BaseButton
          variant={BUTTON_VARIANTS.LINK}
          size={BUTTON_SIZES.SMALL}
          leadingIcon={<MenuOutlined />}
          onClick={onMenuClick}
        />
      </div>

      <div className="mobile-header-center flex flex-1 justify-center items-center min-w-0">
        <Link to="/" className="mobile-header-logo-link">
          <img
            className="mobile-header-logo"
            src={PrmeLogo}
            alt={t("layouts.labels.logo")}
          />
        </Link>
      </div>

      <div
        className="mobile-header-actions flex items-center justify-end gap-300 flex-shrink-0"
        aria-label={t("layouts.labels.headerActions")}
      >
        <NotificationsPopover placement={"bottom"}>
          {({ isOpen, unreadCount }) => (
            <NotificationsSidebarTrigger
              variant={SIDEBAR_TRIGGER_VARIANT.HEADER}
              isCollapsed
              isOpen={isOpen}
              unreadCount={unreadCount}
            />
          )}
        </NotificationsPopover>

        <AccountPopover currentUser={currentUser} placement={"bottomRight"}>
          {({ isOpen }) => (
            <AccountSidebarTrigger
              variant={SIDEBAR_TRIGGER_VARIANT.HEADER}
              isCollapsed
              currentUser={currentUser}
              isOpen={isOpen}
            />
          )}
        </AccountPopover>
      </div>
    </header>
  );
};

export default MobileHeader;
